<template>
      <a href="#" @click="confirmStatus"><span>{{ (params.value === 1)? 'Show' : 'Hide' }}</span></a>
</template>

<script>
import PaymentService from "@/services/PaymentService"
import UtilService from "@/services/UtilService"
export default {
  name: 'CellRendererStatus',
  methods: {
    confirmStatus () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Visibility',
        text: `Are you sure you want to ${(this.params.value === 1)? 'show' : 'hide'} this record ${(this.params.value === 1)? 'to': 'from'} the partner?`,
        accept: this.editStatus,
        acceptText: 'Confirm'
      })
    },
  editStatus(){
  let statusVal = this.params.value === 1 ? 0 : 1
    PaymentService.updateStatus(this.params.data.Id, statusVal,this.userInfo['Id'])
    .then(() => {
    this.$router.push("/apps/payments/payment-list");
    UtilService.notifySuccessAlert(
    this.$vs,
    "Payment updated successfully."
      );
      })
    .catch(e => {
    console.log(e);
    });
  }
  },
  created(){
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
